import { PORTLET_FETCH_SUCCESS } from 'js/components/system/Portlet';
import { SET_CONFIG } from 'js/components/hocs/withRGPortlet';
import parse from './parse';

export const defaultState = {};

export default (reducerSuffix) => (state = defaultState, action) => {
    switch (action.type) {
        case PORTLET_FETCH_SUCCESS:
        case PORTLET_FETCH_SUCCESS + reducerSuffix : {
            const { response, fetchPortlet } = action.payload;
            const productLimits = parse(response, state.config);

            return {
                ...state,
                productLimits,
                fetchPortlet
            };
        }

        case SET_CONFIG:
        case SET_CONFIG + reducerSuffix: {
            const { config } = action.payload;

            return {
                ...state,
                config
            };
        }

        default:
            return state;
    }
};
